import { RATINGS } from '@common/constants'
import { Stars } from '@components/common/icons/custom-icons'
import { FastlyImage } from '@components/common/image'
import TrustBox from './trust-box'

const COMMON_IMAGE_PATH = '/images/common/partners/'

type RatingsProps = {
  isDarkText?: boolean
  showGlassdoor?: boolean
  className?: string
}

const Ratings = ({
  isDarkText = false,
  showGlassdoor = false,
  className = '',
}: RatingsProps) => {
  return (
    <div
      className={`flex gap-x-8 gap-y-4 items-start justify-center text-white flex-wrap ${className}`}
    >
      <div>
        <FastlyImage
          src={`${COMMON_IMAGE_PATH}google-medium.png`}
          webpSrc={`${COMMON_IMAGE_PATH}google-medium.webp`}
          width={60}
          height={20}
          alt="Google Logo"
        />
        <Stars className="my-2" />
        <p className={`${isDarkText && 'text-grey'}`}>
          {RATINGS.GOOGLE_RATING.rating} / 5 stars
        </p>
      </div>
      <TrustBox isDarkText={isDarkText} />
      {showGlassdoor && (
        <div>
          <FastlyImage
            src={`${COMMON_IMAGE_PATH}glassdoor.png`}
            width={100}
            height={42}
            alt="Glassdoor Logo"
          />
          <p className={`${isDarkText && 'text-grey'} mt-2`}>
            {RATINGS.GLASSDOOR_RATING.rating} / 5 stars
          </p>
        </div>
      )}
    </div>
  )
}
export default Ratings
